import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeSlash } from "@phosphor-icons/react";

/**
 * Password-style input with a reveal toggle. Always renders masked by default
 * so credentials cannot be seen by accident. Passes through all other props.
 */
export function SecretInput({ className = "", value, onChange, testId, ...rest }) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <Input
        {...rest}
        type={visible ? "text" : "password"}
        value={value ?? ""}
        onChange={onChange}
        autoComplete="off"
        spellCheck={false}
        className={`${className} pr-9`}
        data-testid={testId}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        tabIndex={-1}
        data-testid={testId ? `${testId}-toggle` : undefined}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded text-[#71717A] hover:text-white hover:bg-[#27272A]"
        aria-label={visible ? "Ocultar" : "Mostrar"}
      >
        {visible ? <EyeSlash size={14} /> : <Eye size={14} />}
      </button>
    </div>
  );
}
